import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import checkedSvg from "../../../../assets/checked.svg";
import searchSvg from "../../../../assets/search-icon.svg";
import urlIcon from "../../../../assets/discovery.svg";
import arrowDownSvg from "../../../../assets/arrow-down-1.svg";
import ModalDetail from "./ModalDetail";
import { baseURL } from "../../../../misc/http";
import useWindowDimensions from "../../../../misc/windowDimensions";
import Chip from "./Chip";

export default function MainOrganizer({ organizer, categories }) {
  const [checked, setChecked] = useState("semua");
  const [search, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedID, setSelectedID] = useState(null);
  const [kategori, setKategori] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedOrganizer, setSelectedOrganizer] = useState("");

  const { height, width } = useWindowDimensions();

  const option = [
    {
      label: "Semua",
      value: "semua",
    },
    {
      label: "PSrE Instansi",
      value: "PSrE Instansi",
    },
    {
      label: "PSrE Non-Instansi",
      value: "PSrE Non-Instansi",
    },
  ];

  const handleFilter = (organizer) => {
    return organizer.filter((item) => {
      console.log("itemkat", item.categories);
      let categories = item.categories
        ? item.categories.split(",").map((e) => e.split("|")[0])
        : [];
      if (checked === "semua")
        return (
          item.companyName.toUpperCase().includes(search.toUpperCase()) &&
          ((kategori && categories && categories.includes(kategori)) ||
            !kategori)
        );
      else
        return (
          item.companyName.toUpperCase().includes(search.toUpperCase()) &&
          item.type === checked &&
          ((kategori && categories && categories.includes(kategori)) ||
            !kategori)
        );
    });
  };

  useEffect(() => {
    if (selectedID) setOpenModal(true);
  }, [selectedID]);

  return (
    <>
      <div
        style={{
          backgroundColor: "#F9F9FA",
        }}
      >
        <div className="container">
          <div
            className="row"
            style={{
              height: width < 1024 ? "1100px" : "600px",
              padding: "48px 0px 0px 0px",
            }}
          >
            <div className="col-lg-4 col-12 container mb-0">
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    padding: "10px 30px 10px 30px",
                  }}
                >
                  <img
                    className="mb-0 btn-checked"
                    src={searchSvg}
                    alt="search"
                    style={{
                      height: "15px",
                      objectFit: "contain",
                      marginRight: 10,
                    }}
                  />
                  <input
                    type="text"
                    className="p-nunito"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      flex: 1,
                      borderWidth: "0px",
                      padding: "5px 7px",
                      color: "black",
                    }}
                    placeholder="Cari Nama PSrE Disini ..."
                  />
                </div>
                <div style={{ height: "1px", backgroundColor: "#E5E5E5" }} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "20px 30px 0px 30px",
                  }}
                >
                  <p
                    className="p-nunito"
                    style={{ margin: "0px", fontWeight: 700 }}
                  >
                    Kategori PSrE
                  </p>
                </div>
                <div style={{ height: "10px" }} />
                {option.map((item, i) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      margin: "10px 0px 0px 40px",
                      cursor: "pointer",
                    }}
                    onClick={() => setChecked(item.value)}
                    key={i + item.label}
                  >
                    <div style={{ marginRight: "10px" }}>
                      {checked === item.value ? (
                        <img
                          className="mb-0 btn-checked"
                          src={checkedSvg}
                          alt="checked"
                          style={{ height: "30px", objectFit: "contain" }}
                        />
                      ) : (
                        <div
                          style={{
                            height: "30px",
                            width: "30px",
                            backgroundColor: "white",
                            border: "1px solid #DADADA",
                            borderRadius: "10px",
                          }}
                          className="btn-checked"
                        />
                      )}
                    </div>
                    <p className="p-nunito" style={{ margin: 0 }}>
                      {item.label}
                    </p>
                  </div>
                ))}
                <div
                  style={{
                    padding: "20px 30px 0px 30px",
                  }}
                >
                  <p
                    className="p-nunito"
                    style={{ margin: "0px", fontWeight: 700 }}
                  >
                    Layanan PSrE
                  </p>
                </div>
                {/* <div
                  style={{
                    border: "0.2px solid #000000",
                    borderRadius: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "17px 30px",
                    padding: "10px 24px",
                  }}
                >
                  <p className="p-nunito" style={{ margin: 0 }}>
                    Pilih Kategori Layanan
                  </p>
                  <img
                    className="mb-0 btn-checked"
                    src={arrowDownSvg}
                    alt="arrow"
                    style={{ height: "15px", objectFit: "contain" }}
                  />
                </div> */}
                <div style={{ padding: "10px 30px 0px" }}>
                  <Select
                    options={categories}
                    placeholder="Pilih Kategori"
                    onChange={(item) => setKategori(item.value)}
                  />
                </div>
                <div style={{ height: "28px" }} />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    onClick={() => {
                      setKategori(null);
                      setSearch("");
                      setChecked("semua");
                    }}
                    style={{
                      backgroundColor: "#1672BD",
                      color: "white",
                      border: "1px solid #1672BD",
                    }}
                    className="nav-link btn p-nunito btn-instance"
                  >
                    Reset Filter
                  </div>
                </div>
                <div style={{ height: "28px" }} />
              </div>
            </div>
            <div
              className="col-lg-8 col-12"
              style={{ height: "552px", overflow: "auto" }}
            >
              {organizer.length > 0 && handleFilter(organizer).length > 0 ? (
                handleFilter(organizer).map((item, idx) => {
                  // console.log("checking item ", item);

                  let getSubCategories = (category) =>
                    item.subCategories.split(",").filter((subCategory) => {
                      return (
                        subCategory.split("-")[0].trim() ===
                        category.split("|")[0].trim()
                      );
                    });

                  return (
                    <div
                      style={{
                        padding: "30px 28px 30px 28px",
                        backgroundColor: "white",
                        borderRadius: 10,
                        marginBottom: 17,
                      }}
                      key={idx + item.companyName}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            height: 27,
                            width: 100,
                            // backgroundColor: "red",
                            marginRight: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            className="mb-0"
                            src={baseURL + item.logo}
                            alt="logo"
                            style={{ width: "100%", objectFit: "cover" }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            marginRight: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flex: 1,
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <p
                              className="p-nunito"
                              style={{
                                marginBottom: "0px",
                                fontWeight: 700,
                                marginRight: "10px",
                              }}
                            >
                              {item.companyName}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginRight: 20,
                              }}
                            >
                              <img
                                className="mb-0"
                                src={urlIcon}
                                alt="icon"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  objectFit: "cover",
                                  borderRadius: 5,
                                  marginRight: 5,
                                }}
                              />
                              <a
                                href={item.website}
                                className="p-nunito"
                                style={{
                                  marginBottom: "0px",
                                  color: "#1672BD",
                                }}
                              >
                                {item.website}
                              </a>
                            </div>
                            <p
                              className="p-nunito d-none d-md-block"
                              style={{ marginBottom: "0px", color: "#1672BD" }}
                            >
                              {item.type}
                            </p>
                          </div>
                        </div>
                        <div>
                          <div
                            onClick={() => setSelectedID(item._id)}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid black",
                              cursor: "pointer",
                            }}
                            className="nav-link btn p-nunito btn-instance"
                          >
                            Info Detail
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          height: 1,
                          backgroundColor: "#E5E5E5",
                          margin: "20px 0px 20px 122px",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          flexWrap: "wrap",
                          marginLeft: 122,
                        }}
                      >
                        {item.categories &&
                          item.categories
                            .split(",")
                            .map((category, i) => (
                              <Chip
                                category={category}
                                subCategories={getSubCategories(category)}
                                setSelectedCategory={(_category) =>
                                  setSelectedCategory(
                                    _category === selectedCategory
                                      ? ""
                                      : _category
                                  )
                                }
                                selectedCategory={selectedCategory}
                                _key={i + category}
                                organizer={item._id}
                                selectedOrganizer={selectedOrganizer}
                                setSelectedOrganizer={setSelectedOrganizer}
                              />
                            ))}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div>no data founded</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalDetail
        isOpen={openModal}
        closeModal={() => {
          setSelectedID(null);
          setOpenModal(false);
        }}
        id={selectedID}
      />
    </>
  );
}
